import React from "react";
import { Typography } from "antd";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";
import { AssessmentTimer } from "../assessmentTimer";

const ActionButtons: React.FC = () => {
  const { aiAssessmentDetails } = useAIAssessmentContext();

  return (
    <div className="action-buttons-container">
      <Typography.Title level={5} style={{ margin: "0px" }}>
        {aiAssessmentDetails?.roundName || "AI Assessment Round"}
      </Typography.Title>
      <div className="action-buttons-right-container">
        <AssessmentTimer />
      </div>
    </div>
  );
};

export default ActionButtons;
